import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { calificacionesPorRevisar } from "../../utils/Datos";
import { UrlWs } from "../../utils/Global";
import { PlaceholderTabla } from "../Otros/Placeholder";

export const PorRevisar = ({ procesoActivo, sesionActiva,setCantidad }) => {
  const [cargando, setCargando] = useState(false);
  const [datos, setDatos] = useState();
  let navigate = useNavigate();

  useEffect(() => {
    if (procesoActivo != null && typeof procesoActivo != "undefined") {
      setCargando(true);
      calificacionesPorRevisar(procesoActivo.id_process).then((respuesta) => {
        if (respuesta.status === true) {
          setDatos(respuesta.datos);
          setCantidad(respuesta.datos.length);
        } else {
          Swal.fire({
            title: "Error",
            text: "Ocurrió un error al cargar el listado de calificaciones pendientes",
            icon: "error",
            confirmButtonText: "Ok",
          });
        }
        setCargando(false);
      });
    }
  }, [procesoActivo]);

  /*
  const handleClick = (id_participant, id_prequalifications) => {
    const url = `/ratificar/${id_participant}/${id_prequalifications}`;
    navigate(url, {});
  };*/
  const handleClick = (id_participant, id_prequalifications) => {
    const url = `/ratificar/${id_participant}/${id_prequalifications}/${sesionActiva["id_session"]}`;
    navigate(url, {});
  };

  return cargando || datos == null ? (
    <PlaceholderTabla></PlaceholderTabla>
  ) : (
    <table className="table table-rounded table-striped border gy-7 gs-7">
      <thead>
        <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
          <th>Etapa</th>
          <th>Rut</th>
          <th>Nombre</th>
          <th>Dirección</th>
          <th>Unidad</th>
          <th>Precalificar</th>
          {sesionActiva !== false && sesionActiva !== null ? (
            <th>Autorizar</th>
          ) : (
            <></>
          )}
        </tr>
      </thead>
      <tbody>
        {datos.length > 0 ? (
          datos.map((dato) => {
            return (
              <tr key={dato.id_qualifications}>
                <td>{dato.id_stages}</td>
                <td>{dato.rutOfficer}</td>
                <td>{dato.nameOficcer}</td>
                <td>{dato.nameDmunicipal}</td>
                <td>{dato.nameUmunicipal}</td>
                <td>{dato.namePrequalifier}</td>
                {sesionActiva !== false && sesionActiva !== null ? (
                  <td>
                    <button
                      className="btn btn-sm btn-primary"
                      onClick={() =>
                        handleClick(dato.id_participant, dato.id_qualifications)
                      }
                    >
                      Ratificar
                    </button> 
                  </td>
                ) : (
                  <></>
                )}
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan={6}>No hay datos para mostrar</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
